export const navLinks = [
  { id: "home", label: "首页" },
  { id: "featured", label: "热门笑点" },
  { id: "collections", label: "片段合集" },
  { id: "latest", label: "最新连载" },
  { id: "voices", label: "读者口碑" },
  { id: "faq", label: "常见问题" },
];

export const categories = [
  {
    id: "daily",
    title: "搞笑日常",
    desc: "柴米油盐里的无厘头瞬间",
    icon: "ri-cup-line",
    count: 186,
  },
  {
    id: "office",
    title: "职场摸鱼",
    desc: "打工人的快乐与辛酸",
    icon: "ri-briefcase-line",
    count: 132,
  },
  {
    id: "food",
    title: "干饭现场",
    desc: "吃货的自我修养",
    icon: "ri-restaurant-line",
    count: 98,
  },
  {
    id: "pets",
    title: "毛孩子日常",
    desc: "被猫狗支配的日子",
    icon: "ri-ghost-line",
    count: 76,
  },
  {
    id: "school",
    title: "校园趣事",
    desc: "课堂之外的欢乐",
    icon: "ri-school-line",
    count: 89,
  },
  {
    id: "travel",
    title: "旅行囧记",
    desc: "在路上笑料不断",
    icon: "ri-flight-takeoff-line",
    count: 54,
  },
];

export const featuredComics = [
  {
    id: 1,
    tag: "爆笑推荐",
    title: "今天也是元气满满的一天",
    subtitle: "闹钟响了八百遍，丫头在梦里和周公辩论了三十回合……",
    chapter: "第 128 话",
    likes: 28900,
    comments: 1204,
    img: "https://readdy.ai/api/search-image?query=cheerful%20cartoon%20girl%20jumping%20out%20of%20bed%20in%20the%20morning%20with%20sunlight%2C%20playful%20manga%20style%20illustration%2C%20warm%20orange%20and%20cream%20palette%2C%20bold%20comic%20lines%2C%20laughing%20expression%2C%20cozy%20bedroom%20background&width=800&height=600&seq=featured-comic-01&orientation=landscape",
  },
  {
    id: 2,
    tag: "职场篇",
    title: "老板不在的第三十分钟",
    subtitle: "会议室门口探头三次，摸鱼大业正式启动……",
    chapter: "第 96 话",
    likes: 24500,
    comments: 982,
    img: "https://readdy.ai/api/search-image?query=cartoon%20girl%20sneaking%20around%20a%20modern%20office%20checking%20around%20corner%2C%20playful%20workplace%20comedy%20manga%20illustration%2C%20warm%20orange%20tones%2C%20funny%20expression%2C%20bold%20comic%20style&width=800&height=600&seq=featured-comic-02&orientation=landscape",
  },
  {
    id: 3,
    tag: "干饭篇",
    title: "减肥?不存在的",
    subtitle: "点外卖前信誓旦旦吃轻食，下单时默默加了鸡排……",
    chapter: "第 203 话",
    likes: 22300,
    comments: 1105,
    img: "https://readdy.ai/api/search-image?query=cartoon%20girl%20happily%20eating%20a%20large%20delicious%20meal%20at%20a%20restaurant%20table%2C%20food%20addiction%20comedy%20manga%20illustration%2C%20warm%20orange%20and%20cream%20palette%2C%20playful%20expression%2C%20delicious%20food%20on%20table&width=800&height=600&seq=featured-comic-03&orientation=landscape",
  },
];

export const collections = [
  {
    id: "daily-coll",
    title: "大头贴合集 · 日常一箩筐",
    desc: "早起、通勤、网购、追剧……丫头日常的每一个翻车瞬间都在这里。",
    count: 86,
    views: 45800,
    img: "https://readdy.ai/api/search-image?query=grid%20of%20multiple%20small%20comic%20panels%20showing%20daily%20life%20moments%2C%20cartoon%20girl%20doing%20various%20funny%20activities%2C%20playful%20manga%20collage%20style%2C%20warm%20orange%20cream%20palette%2C%20funny%20everyday%20scenes&width=640&height=480&seq=collection-daily&orientation=landscape",
  },
  {
    id: "office-coll",
    title: "摸鱼大师速成课",
    desc: "职场打工人必看，丫头的上班生存法则与快乐摸鱼指南。",
    count: 64,
    views: 37100,
    img: "https://readdy.ai/api/search-image?query=cartoon%20workspace%20desk%20with%20laptop%2C%20coffee%20and%20notebooks%2C%20playful%20office%20comedy%20manga%20style%20collage%20panels%2C%20warm%20orange%20tones%2C%20funny%20work%20scenes&width=640&height=480&seq=collection-office&orientation=landscape",
  },
  {
    id: "food-coll",
    title: "干饭人生快乐指南",
    desc: "从早餐到宵夜，丫头的吃货日常让你笑到停不下来。",
    count: 58,
    views: 33200,
    img: "https://readdy.ai/api/search-image?query=colorful%20comic%20panels%20of%20food%20and%20eating%20scenes%2C%20cartoon%20girl%20enjoying%20meals%2C%20playful%20food%20manga%20collage%2C%20warm%20orange%20cream%20palette%2C%20delicious%20funny%20scenes&width=640&height=480&seq=collection-food&orientation=landscape",
  },
  {
    id: "pets-coll",
    title: "被猫统治的日子",
    desc: "丫头的毛孩子军团，一场人与猫的大乱斗持续上映。",
    count: 42,
    views: 29800,
    img: "https://readdy.ai/api/search-image?query=cartoon%20cats%20and%20dogs%20causing%20chaos%20in%20a%20cozy%20room%20with%20a%20girl%2C%20playful%20pet%20comedy%20manga%20collage%20panels%2C%20warm%20orange%20cream%20tones%2C%20funny%20pet%20antics&width=640&height=480&seq=collection-pets&orientation=landscape",
  },
  {
    id: "school-coll",
    title: "课堂趣闻大合集",
    desc: "班主任的死亡凝视、同桌的骚操作，校园欢乐全收录。",
    count: 39,
    views: 25400,
    img: "https://readdy.ai/api/search-image?query=cartoon%20school%20classroom%20with%20funny%20students%20and%20teacher%2C%20playful%20school%20comedy%20manga%20collage%20panels%2C%20warm%20orange%20cream%20palette%2C%20funny%20classroom%20scenes&width=640&height=480&seq=collection-school&orientation=landscape",
  },
  {
    id: "travel-coll",
    title: "旅行的奇奇怪怪",
    desc: "赶火车、迷路、踩坑餐厅……丫头旅行路上的笑话全集。",
    count: 33,
    views: 22100,
    img: "https://readdy.ai/api/search-image?query=cartoon%20girl%20traveling%20with%20suitcase%20in%20funny%20situations%20at%20train%20station%20and%20scenery%2C%20playful%20travel%20comedy%20manga%20collage%2C%20warm%20orange%20cream%20tones%2C%20funny%20adventure&width=640&height=480&seq=collection-travel&orientation=landscape",
  },
];

export const latestEpisodes = [
  {
    id: 1,
    title: "第 218 话 · 今天的风有点喧嚣",
    desc: "风太大，丫头的刘海和自尊心一起飞走了。",
    tag: "日常",
    date: "08-16",
    hot: true,
  },
  {
    id: 2,
    title: "第 217 话 · 深夜食堂翻车记",
    desc: "立志做宵夜，结果锅和心态一起炸了。",
    tag: "干饭",
    date: "08-14",
    hot: true,
  },
  {
    id: 3,
    title: "第 216 话 · 减肥的第n次失败",
    desc: "办了健身卡就像完成了减肥，丫头如是说。",
    tag: "日常",
    date: "08-12",
    hot: false,
  },
  {
    id: 4,
    title: "第 215 话 · 老板群里的新表情包",
    desc: "手滑发错消息的后果，就是多了个社死名场面。",
    tag: "职场",
    date: "08-10",
    hot: false,
  },
  {
    id: 5,
    title: "第 214 话 · 猫咪越狱事件",
    desc: "全屋大搜捕，最后发现它霸占了枕头。",
    tag: "毛孩子",
    date: "08-08",
    hot: false,
  },
  {
    id: 6,
    title: "第 213 话 · 网购冲动实录",
    desc: "下单一时爽，收货火葬场，钱包表示很难过。",
    tag: "日常",
    date: "08-06",
    hot: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "爱吃橙子的喵",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20cartoon%20avatar%20of%20a%20young%20woman%20with%20orange%20hair%20smiling%2C%20cute%20flat%20manga%20style%2C%20warm%20cream%20background&width=200&height=200&seq=avatar-user-01&orientation=squarish",
    role: "忠实读者 · 追更 2 年",
    text: "每天下班最快乐的事就是看丫头更新，笑点密集又解压，整个人都轻松了。",
    star: 5,
  },
  {
    id: 2,
    name: "办公室小透明",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20cartoon%20avatar%20of%20a%20young%20man%20with%20glasses%20smiling%2C%20cute%20flat%20manga%20style%2C%20warm%20cream%20background&width=200&height=200&seq=avatar-user-02&orientation=squarish",
    role: "职场篇死忠粉",
    text: "摸鱼篇简直是我本人在上班，每次看完都要笑出声，太真实了。",
    star: 5,
  },
  {
    id: 3,
    name: "深夜干饭人",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20cartoon%20avatar%20of%20a%20cute%20girl%20eating%20noodles%20happily%2C%20flat%20manga%20style%2C%20warm%20cream%20background&width=200&height=200&seq=avatar-user-03&orientation=squarish",
    role: "干饭篇铁粉",
    text: "干饭篇每一话都戳中我，丫头就是我本人没错了，更新千万别断！",
    star: 5,
  },
];

export const faqs = [
  {
    q: "大黄丫头漫画多久更新一次？",
    a: "大黄丫头漫画目前每周更新 2-3 话，通常是周二、周四、周六晚上更新。遇到节假日还会有特别篇放出，关注官网即可第一时间追更，搞笑日常轻松看一话不落。",
  },
  {
    q: "大黄丫头漫画可以在手机上轻松看吗？",
    a: "当然可以。大黄丫头漫画官网已针对电脑、平板和手机做了完整的响应式适配，无论用什么设备都能轻松看漫画，支持上下滑动阅读，随时随地享受轻松幽默内容。",
  },
  {
    q: "网站上的笑点合集是免费的吗？",
    a: "是的，大黄丫头漫画官网的搞笑日常与幽默片段合集全部免费，无需注册即可轻松看。部分最新连载内容可免费追更，希望所有喜欢丫头的读者都能获得快乐。",
  },
  {
    q: "可以下载大黄丫头漫画的搞笑片段吗？",
    a: "网站内容仅供个人娱乐学习使用。你可以在线轻松看大黄丫头漫画的幽默片段，但如需转载或商业使用，请通过官网联系页与我们取得授权，谢谢配合。",
  },
  {
    q: "如何第一时间收到大黄丫头漫画的更新提醒？",
    a: "关注大黄丫头漫画官网最新连载栏目，或收藏页面，我们会在每次更新时同步发布最新话标题与摘要，方便你第一时间发现新笑点，轻松追更不迷路。",
  },
];